import BotService from "../../services/bot.service";
import AppService from "@/services/app.service";
import router from '@/router'
import i18n from '../../plugins/i18n.js'
import {getField, updateField} from "vuex-map-fields";
import Vue from "vue";

const state = () => ({
    statusAllBot: null,
    statusCurrentBot: null,
    autoAssignCfg: {
        supporters: []
    },
    loading: false
});
const mutations = {
    setStatusAllBot(state, status) {
        state.statusAllBot = status
    },
    setStatusCurrentBot(state, status) {
        state.statusCurrentBot = status
    },
    setIsChangedStatusAllBot(state, data) {
        state.isChangedStatusAllBot = data
    },
    setAutoAssignCfg(state, data) {
        state.autoAssignCfg = data
    },
    setLoading(state, data) {
        state.loading = data
    },
    updateField
};
const actions = {
    onUpdateAutoAssignCfg({state}, data) {
        if (state.autoAssignCfg) {
            const userId = data.user_id;
            const supporterIdx = state.autoAssignCfg.supporters.findIndex((o=> o.auto_assign_config.user_id === userId))
            if (supporterIdx > -1) {
                Vue.set(state.autoAssignCfg.supporters[supporterIdx].auto_assign_config, 'active', data.active)
            }
        }
    },
    fetchCurrentAutoAssignCfg(context) {
        const botCode = router.currentRoute.params.bot_code;
        if (botCode) {
            context.commit('setLoading', true)
            BotService.getAutoAssignStatus_manage(botCode)
                .then(res => {
                    context.commit('setAutoAssignCfg', res.data)
                })
                .finally(()=> {
                    context.commit('setLoading', false)
                })
        }
    },
    getStatus(context) {
        const botCode = router.currentRoute.params.bot_code;
        if (botCode) {
            BotService.getAutoAssignStatus(botCode)
                .then(res => {
                    context.commit('setStatusAllBot', res.data['status_all_bot']);
                    context.commit('setStatusCurrentBot', res.data['status_current_bot'])
                })
        }
    },
    updateStatusCurrentBot(context) {
        const botCode = router.currentRoute.params.bot_code;
        let status = context.state.statusCurrentBot;
        BotService.updateAutoAssignStatusCurrentBot(botCode, status)
            .then(()=> {
                context.commit('setStatusCurrentBot', status);
                context.commit('setStatusAllBot', null);
                context.dispatch('getStatus');
                AppService.toastSuccess("Update Auto Assign Status Success");
            })
            .catch(()=> {
                AppService.toastError("Update Auto Assign Status Failed");
            })
    },
    async updateStatusAllBot(context) {
        let status = context.state.statusAllBot;
        const confirm = await AppService.confirm(i18n.t('autoAssignConfigConfirm'))
        if (confirm) {
            BotService.updateAutoAssignStatusAllBot(status)
                .then(() => {
                    context.commit('setStatusAllBot', status);
                    context.commit('setStatusCurrentBot', null);
                    context.dispatch('getStatus')
                    AppService.toastSuccess("Update Auto Assign Status Success");
                })
                .catch(() => {
                    AppService.toastError("Update Auto Assign Status Failed");
                })
        }
        else {
            context.commit('setStatusAllBot', null)
            await context.dispatch('getStatus')
        }
    }
};
const getters = {
    getField,
    concurrentAgents(state) {
        if (state.autoAssignCfg && state.autoAssignCfg.supporters.length > 0) {
            const totalAgent = state.autoAssignCfg.supporters.length
            const availableAgent = state.autoAssignCfg.supporters.filter(o => o.auto_assign_config.active).length
            const unavailableAgent = totalAgent - availableAgent;
            return [
                {
                    label: "Available",
                    value: availableAgent,
                    rate: `${((availableAgent / totalAgent) * 100).toFixed(2)} %`
                },
                {
                    label: "Unavailable",
                    value: unavailableAgent,
                    rate: `${((unavailableAgent / totalAgent) * 100).toFixed(2)} %`
                }
            ]
        }
        return []
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
